// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"sT","trailerHeader":"sU","trailers":"sV","trailer":"sW","imgWrapper":"sX","playWrapper":"sY","playImg":"sZ","title":"s0","slipnslideArrow":"s1"};